import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('ShowMoreText', [
  'base',
  'content',
  'focusVisible',
  'cta',
]);

const styles = css`
  .${classes.base} {
    position: relative;
  }

  .${classes.content} {
    margin: var(--cds-spacing-100) 0;
    outline: 1px solid transparent;

    &:focus.${classes.focusVisible} {
      box-shadow: 0 0 0 1px var(--cds-color-interactive-stroke-primary-focus),
        0 0 0 2px var(--cds-color-interactive-stroke-primary-focus-invert);
    }
  }
`;

export default styles;
